// auth-context.js — session bootstrap. Loads the current user from /api/auth/me
// into the global state signal before the router renders. Fail-closed: any error
// leaves user=null (no implicit access).

import { api } from './api-client.js';
import { state } from './state.js';

export async function bootstrapAuth() {
  try {
    const me = await api.get('/api/auth/me');
    state.user.value = me && me.user ? me.user : null;
  } catch {
    state.user.value = null;
  } finally {
    state.booted.value = true;
  }
  return state.user.peek();
}

export async function logout() {
  try { await api.post('/api/auth/logout'); } catch { /* best-effort */ }
  state.user.value = null;
}
